import React, { useRef } from "react";
import lock from "../../assets/images/lock.png";
import email from "../../assets/images/email.png";
import PasswordField from "../common/PasswordField";

export function SignInForm(props) {
	const instanceRef = useRef({ props });
	instanceRef.current.props = props;
	initialConstruct.bind(instanceRef.current)("SignInForm", props);

	const { validate, submit, setState: setParent, formref, store } = props;

	return (
		<form
			ref={formref}
			className="popuplogin"
			onSubmit={(e) => submit(e)}
		>
			<div className="title">Sign Up</div>
			<div className="form-input">
				<i className="fas fa-user icon"></i>
				<input
					type="text"
					className="input"
					placeholder="First Name*"
					name="firstName"
					required
				/>
			</div>
			<div className="form-input">
				<i className="fas fa-user icon"></i>
				<input
					type="text"
					className="input"
					placeholder="Last Name*"
					name="lastName"
					required
				/>
			</div>
			<div className="form-input">
				<img src={email} className="icon" />
				<input
					type="text"
					className="input"
					placeholder="Email Address"
					name="email"
					onChange={(e) => validate(e, "email", formref.current)}
					required
				/>
			</div>
			<div className="form-input">
				<img src={lock} className="icon" />
				<PasswordField
					className="input"
					placeholder="Password"
					name="password"
					onChange={(e) =>
						validate(e, "password", formref.current)
					}
					required
				/>
			</div>
			<div className="form-input">
				<img src={lock} className="icon" />
				<PasswordField
					className="input"
					placeholder="Confirm Password"
					onChange={(e) =>
						validate(e, "confirm_password", formref.current)
					}
					required
				/>
			</div>
			<div className="form-input">
				<span style={{ fontWeight: "bold", color: "red", fontSize: "10px" }}>
					{store.errorMsg}<br/>{store.failureMsg}
				</span>
			</div>
			<div className="form-input">
				<span>
					<input type="checkbox" className="checkbox" name="subscribe" />
					Treat your inbox: splendid discounts, new products and clever ideas.
				</span>
			</div>

			<div className="form-input">
				<button type="submit" className="button" id="signup">
					Sign In Now
				</button>
			</div>
			<div className="form-input">
				Already have an account? &nbsp;
				<label
					className="label"
					onClick={() => setParent({ form: "login" })}
				>
					Sign In
				</label>
			</div>
		</form>
	);
}

export default SignInForm;
